import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import UploadFileRoundedIcon from "@mui/icons-material/UploadFileRounded";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  MenuItem,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useMemo, useState } from "react";

export const OssDocumentUploadDialog = ({ open, orders = [], loading, onClose, onSubmit }) => {
  const [orderLineId, setOrderLineId] = useState("");
  const [documentType, setDocumentType] = useState("PURCHASE_ORDER");
  const [file, setFile] = useState(null);
  const target = useMemo(
    () => orders.find((item) => String(item.order_line_id) === String(orderLineId)),
    [orders, orderLineId]
  );

  const submit = () => {
    if (!target || !file) return;
    onSubmit(file, {
      orderId: target.order_id,
      orderLineId: target.order_line_id,
      documentType,
      userKey: "document.manager",
    }).then(() => {
      setOrderLineId("");
      setDocumentType("PURCHASE_ORDER");
      setFile(null);
    });
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ pr: 6, fontWeight: 900 }}>
        문서 업로드
        <IconButton onClick={onClose} sx={{ position: "absolute", right: 12, top: 10 }}>
          <CloseRoundedIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Stack spacing={1.5}>
          <TextField select fullWidth size="small" label="대상 주문 품목" value={orderLineId} onChange={(e) => setOrderLineId(e.target.value)}>
            {orders.map((order) => (
              <MenuItem key={order.order_line_id} value={order.order_line_id}>
                {order.order_no} / {order.item_name_snapshot}
              </MenuItem>
            ))}
          </TextField>
          <TextField select fullWidth size="small" label="문서 유형" value={documentType} onChange={(e) => setDocumentType(e.target.value)}>
            <MenuItem value="PURCHASE_ORDER">발주서</MenuItem>
            <MenuItem value="ORDER_FORM">주문서</MenuItem>
            <MenuItem value="CHANGE_ORDER">변경 근거</MenuItem>
            <MenuItem value="SPEC">규격서</MenuItem>
            <MenuItem value="OTHER">기타</MenuItem>
          </TextField>
          <Button component="label" variant="outlined" startIcon={<UploadFileRoundedIcon />} sx={{ justifyContent: "flex-start" }}>
            파일 선택
            <input hidden type="file" onChange={(event) => setFile(event.target.files?.[0] || null)} />
          </Button>
          <Typography sx={{ color: "#64748b", fontSize: 13 }}>
            {file ? file.name : "선택된 파일이 없습니다."}
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>취소</Button>
        <Button variant="contained" disabled={loading || !target || !file} onClick={submit}>
          업로드
        </Button>
      </DialogActions>
    </Dialog>
  );
};
